// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRegressionCaseResult" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatRegressionCaseKind } from "./chat-regression-case-kind.enum.gen";
import { ChatRegressionMatchMode } from "./chat-regression-match-mode.enum.gen";
import { ChatRegressionJudgeComparisonGenShape } from "./chat-regression-judge-comparison.gen";
import { ChatRegressionClarifierExpectation } from "./chat-regression-clarifier-expectation.enum.gen";
import { ChatRoutingOutcome } from "./chat-routing-outcome.enum.gen";

export const ChatRegressionCaseResultGenShape = z.strictObject({
  caseId: z.string(),
  groupId: z.string(),
  redactedInput: z.string(),
  kind: z.enum(ChatRegressionCaseKind),
  draft: z.boolean(),
  matchMode: z.enum(ChatRegressionMatchMode),
  expectedAdviceSetIds: z.array(z.string()),
  expectedCrisisFlags: z.array(z.string()),
  expectedTenure: z.string().optional(),
  resolvedTenure: z.string().optional(),
  topMatchId: z.string().optional(),
  matchedAdviceSetIds: z.array(z.string()),
  shortlistIds: z.array(z.string()),
  perIssueShortlistIds: z.array(z.array(z.string())),
  judgeComparisons: z.array(ChatRegressionJudgeComparisonGenShape),
  detectedCrisisFlags: z.array(z.string()),
  expectedIssueCount: z.number().optional(),
  detectedIssueCount: z.number(),
  clarifierRounds: z.number(),
  clarifierExpectation: z.enum(ChatRegressionClarifierExpectation),
  passed: z.boolean(),
  costUsd: z.number(),
  decisionLogId: z.string().optional(),
  outcome: z.enum(ChatRoutingOutcome),
});
